import {WlModal} from "../../../webcomponents/modal/modal.component";
import localStorage from "../../../core/localStorage";
import dom from "../../../core/dom";
import actions from "../../../../../mitula/ts/components/retention/email/form/actions";
import FormValidations from "../../../forms/validator/FormValidations";


export default class SaveSearchModal {

    private readonly saveSearchModal: WlModal
    private readonly isPaid: boolean
    private readonly isDesktop: boolean
    private readonly search: string
 //   private readonly ids: Map<string, string>
    saveActualSearchFormId: string

    constructor(search:string,isPaid: boolean, isDesktop: boolean, saveActualSearchFormId:string) {
        this.search = search
        this.isPaid = isPaid
        this.isDesktop = isDesktop
       // this.ids = ids
        this.saveSearchModal = document.querySelector<WlModal>('#js_save-actual-search-modal')!
        this.saveActualSearchFormId = saveActualSearchFormId
    }

    public init = () => {
        actions.init();
        this.setupEventListeners();
    };

    private setupEventListeners = () => {
        if (this.saveSearchModal) {
            const saveSearchCTA = dom.select("#save-search-opener");
            saveSearchCTA?.addEventListener('click', () => {
                this.openModal()
            });

            let saveActualSearchButton = document.querySelector('.js_save-email');
            saveActualSearchButton?.addEventListener('click', () => {
                let formElement = dom.select(`#${this.saveActualSearchFormId}`) as HTMLFormElement;
                const formData = new FormData(formElement);
                formData.append("search", this.search);
                let emailValue = formData.get("email")?.toString() ?? "";
                let emailInput = formElement.querySelector("input");
                if(FormValidations.emailIsValid(emailValue) ){
                    emailInput?.classList.remove("error");
                    actions.submitSaveActualSearchForm(formData, this.saveActualSearchFormId, this.isPaid, this.saveActualSearchFormId, this.isDesktop)
                    this.saveSearchModal.close();
                } else {
                    emailInput?.classList.add("error");
                }
            });

            let saveSimilarSearchButtons = document.querySelectorAll('.js_save-similar-search-button');
            saveSimilarSearchButtons?.forEach((button) => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    // @ts-ignore
                    alert("voy a guardar la búsqueda "+ button.dataset.search);
                });
            });
        }
    };

    public openModal = () => {
        this.saveSearchModal.open();
        let emailValue = localStorage?.getItem("email") ?? "";
        emailValue = emailValue ? emailValue : "";
        actions.clickSaveActualSearchCTA(this.saveActualSearchFormId, emailValue, this.isPaid, this.isDesktop);
    }
}
